import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for retrieving token information
 */
const create = () => { 
    
    const api = BaseApi.create();
    
    const getToken = (code) => {
        var payload = {
            code: code,
            redirectUri: window.location.origin + '/callback'
        };
        return api.getWithPayload(ApiPaths.GET_TOKEN, payload);
    }
   
    // Return back a collection of functions
    return {
        getToken
    }
}

// let's return back our create method as the default.
export default {
    create
}